<template>
  <div
    class="tw-animate-pulse tw-w-full mod-util-ratio-16-9 tw-max-h-96 tw-relative game-tile-background-color"
  >
    <font-awesome-icon
      class="tw-absolute tw-fill-current tw-top-1/2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-text-5xl md:tw-text-6xl tw-opacity-20"
      icon="image"
    />
  </div>
</template>
